var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505.64 429.32-.91-1.23c-18.76-21.72-41.81-37.63-64.1-53-9.1-6.28-25.27-16.4-36.71-24.54a221.24 221.24 0 0 0 40.69-128.25c0-122.77-99.53-222.3-222.31-222.3s-222.3 99.53-222.3 222.3 99.53 222.31 222.3 222.31a221.33 221.33 0 0 0 128.11-40.61c8.15 11.43 18.26 27.57 24.55 36.67 15.41 22.33 31.34 45.33 53.04 64.07l1.23.9a43.33 43.33 0 0 0 23 6.36 49.55 49.55 0 0 0 33.15-12.86l13.42-13.39.32-.33c14.29-15.64 17.03-39.23 6.52-56.1zm-283.34-42.71a164.33 164.33 0 1 1 116.18-48.13 163.23 163.23 0 0 1 -116.18 48.13z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 177.56,
    r: 65.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.79 296.61a40.13 40.13 0 0 0 -11.6-24.18 40.84 40.84 0 0 0 -24.36-11.74c-13.49-1.43-47-2.21-67.87-2.21s-61.94.78-75.44 2.21a40.89 40.89 0 0 0 -24.36 11.73 40.12 40.12 0 0 0 -11.59 24.18v.28c-.32 3.1-.51 5.79-.63 8.09a138.59 138.59 0 0 0 12 13.72 136.32 136.32 0 0 0 192.77 0 139.11 139.11 0 0 0 11.83-13.49c-.15-2.35-.37-5.11-.7-8.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8290b4d6ad6009f2bab77ab919bf7849.svg";
export { ForwardRef as ReactComponent };